<template>
  <v-container>
      <v-row class="tela" justify="center" align="center">
          <v-col col="1" class="text-center">
              <v-progress-circular size="50" indeterminate color="primary">

              </v-progress-circular>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style scoped>
.tela{
        background-color: rgba(220, 220, 255, 0.8);
        height: calc(100vh - 84px);
        border-radius: 6px;
    }


</style>